import { render, staticRenderFns } from "./MarketComparison.vue?vue&type=template&id=de1149d0&scoped=true&"
import script from "./MarketComparison.vue?vue&type=script&lang=js&"
export * from "./MarketComparison.vue?vue&type=script&lang=js&"
import style0 from "./MarketComparison.vue?vue&type=style&index=0&id=de1149d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de1149d0",
  null
  
)

export default component.exports